import { PatientVisit } from 'src/ts';

export const isVisitPending = (visit: PatientVisit) => {
  return visit.Estado_de_la_visita.toLocaleLowerCase().includes('visita pendiente') || 
  visit.Estado_de_la_visita.toLocaleLowerCase().includes('visita en proceso') ||
  visit.Estado_de_la_visita.toLocaleLowerCase().includes('visita pendiente de pago'); 
  //&& new Date(visit.Fecha_de_la_visita_raw) >= new Date();
}